import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useDropzone } from 'react-dropzone';
import Select from 'react-select';
import { showCategories } from '../../../../../services/operations/categoryAPI';
import { createImage } from '../../../../../services/operations/ImageAPI';
import { toast } from 'react-hot-toast';
import ImageTable from "./ImageTable"

const ImageUploadForm = () => {
    const { register, handleSubmit, control } = useForm();
    const [categories, setCategories] = useState([]);
    const [files, setFiles] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const data = await showCategories();
                const formattedCategories = data.map((cat) => ({
                    value: cat._id,
                    label: cat.name,
                }));
                setCategories(formattedCategories);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchCategories();
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: (acceptedFiles) => {
            setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
        },
    });

    const onSubmit = async (data) => {
        if (files.length === 0) {
            toast.error('Please select at least one image.');
            return;
        }

        try {
            const formData = new FormData();
            files.forEach((file) => formData.append('images', file));
            formData.append('category', data.category.value);
            formData.append('description', data.description);
            
            await createImage(formData)();
            toast.success('Image uploaded successfully');
            setFiles([]);
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        }
    };

    return (
        <div>
          <form onSubmit={handleSubmit(onSubmit)} className="bg-white shadow-md rounded-lg p-6 max-w-md mx-auto">
            <h2 className="text-2xl font-semibold text-center mb-6">Upload Your Images</h2>
            <div 
                {...getRootProps()} 
                className="border-dashed border-2 border-gray-300 p-4 text-center mb-4 hover:bg-gray-100 transition duration-200"
            >
                <input {...getInputProps()} />
                <p className="text-gray-500">Drag 'n' drop some files here, or click to select files</p>
            </div>

            {files.length > 0 && (
                <div className="mb-4">
                    <h4 className="text-lg font-medium">Selected Images:</h4>
                    <ul className="list-disc pl-5 text-gray-700">
                        {files.map((file) => (
                            <li key={file.name}>{file.name}</li>
                        ))}
                    </ul>
                </div>
            )}

            <div className="mb-4">
                <label htmlFor="category" className="block text-gray-700 font-medium mb-1">Category</label>
                <Controller
                    name="category"
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            options={categories}
                            placeholder="Select category"
                            className="basic-single"
                            classNamePrefix="select"
                            classNameContainer="mb-2"
                        />
                    )}
                />
            </div>

            <div className="mb-4">
                <label htmlFor="description" className="block text-gray-700 font-medium mb-1">Description</label>
                <textarea
                    id="description"
                    name="description"
                    {...register('description', { required: true })}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    rows="4"
                    placeholder="Enter a description..."
                />
            </div>

            <button 
                type="submit" 
                className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition duration-200"
            >
                Upload Image
            </button>
        </form>
        <div>
          <ImageTable/>
        </div>
        </div>
    );
};

export default ImageUploadForm;
